import {FC} from "react";
import {Box, BoxProps, Typography} from "@mui/material";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	contentBox: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(2.5),
		backgroundColor: theme.palette.background.paper,
		borderWidth: theme.borderWidth.small,
		borderColor: theme.palette.grey[100],
		borderStyle: "solid",
		borderRadius: theme.borderRadius.small
	},
	hr: {
		borderTop: 0,
		borderColor: theme.palette.grey[100]
	},
	contentContainer: {
		display: "flex",
		gap: theme.spacing(3),
		flexDirection: "column",
		"& span": {
			fontWeight: 700
		}
	}
}));

interface ICustomProps {
	courseId: number | undefined,
	course?: {
		description?: string | null;
		moduleCount?: number;
		contentType?: string | null;
		enrollmentCount?: number;
		cohortMembersEnrollmentCount?: number;
	}
}

export type IProps = Omit<BoxProps, "children"> & ICustomProps;


export const OverviewTab:FC<IProps> = ({courseId, course, ...baseProps}) => {
	const {classes} = useStyles();

	return <Box {...baseProps}>
		<Box className={classes.contentBox}>
			<AdminHeader title="Course Overview" />
			<Box className={classes.contentContainer}>
				{course ? <>
					<Typography variant="body1">{course.description}</Typography>
					<hr className={classes.hr}/>
					<Typography variant="body1"><span>Number of Lessons: </span>{course.moduleCount ?? 0}</Typography>
					<Typography variant="body1"><span>Content Type:  </span>{course.contentType ?? 'N/A'}</Typography>
					<Typography variant="body1"><span>Global Enrollments:  </span>{course.enrollmentCount ?? 0}</Typography>
					<Typography variant="body1"><span>Internal Enrollments:  </span>{course.cohortMembersEnrollmentCount ?? course.enrollmentCount ?? 0}</Typography>
				</>: null}
			</Box>
		</Box>
	</Box>
}
